const isEmail = (word: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(word);
};

export function sanitizeFeedback(feedback: string): string {
  if (typeof feedback !== "string" || !feedback.trim()) return "";

  // Check for HTML tags
  if (/<[^>]*>/g.test(feedback)) return "";

  // Check for URLs or suspicious content
  const words = feedback.split(/\s+/);
  for (const word of words) {
    // Check for emails
    if (isEmail(word)) return "";

    // Check for URLs (protocols, www, domains with TLDs)
    if (
      word.includes("http://") ||
      word.includes("https://") ||
      word.includes("www.") ||
      word.includes("://") ||
      /[a-z]+\.[a-z]{2,}/i.test(word)
    ) {
      return "";
    }
  }

  return feedback.trim();
}

export default {
  sanitizeFeedback
};
